import { render, staticRenderFns } from "./AvatarsGroup.vue?vue&type=template&id=48b3d814&scoped=true&"
import script from "./AvatarsGroup.vue?vue&type=script&lang=ts&"
export * from "./AvatarsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarsGroup.vue?vue&type=style&index=0&id=48b3d814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b3d814",
  null
  
)

export default component.exports